import { atom } from 'jotai';

const feedbackTopicsAtoms = atom([]);

export {
  feedbackTopicsAtoms,
};
